export default {
  SET_CONFIG(state, payload) {
    localStorage.setItem('CONFIG_PAYLOAD',JSON.stringify(payload))
    state.config = payload;
  },
  SET_LOOKUPS(state, payload) {
    localStorage.setItem('LOOKUPS_PAYLOAD',JSON.stringify(payload))
    state.lookups = payload;
  },
};
